<script>
    import { userEmail } from "/src/store";
    import { t, locale } from "$lib/translations";
    import axiosInstance from "$lib/js/axios.js";

    import UserIcon from "$lib/images/user.svg";
    import EmailIcon from "$lib/images/email.svg";
    import PassIcon from "$lib/images/pass.svg";
    import Spinner from "./Spinner.svelte";

    import Turnstile from "./Turnstile.svelte";

    export let changeFormStep;
    let token = "";
    let showPassword = false;
    let showRepeat = false;

    let login_error = "";
    let email_error = "";
    let password_error = "";
    let repeat_error = "";
    let turnstile_error = "";
    let user_agreement = true;
    let user_agreement_error = "";
    let isSubmitting = false;

    const blockedDomains = ["mailinator.com", "10minutemail.com", "guerrillamail.com", "yopmail.com", "tempmail.com"];
    function isBlockedEmail(email) {
        return blockedDomains.some(domain => email.endsWith("@" + domain));
    }

    async function register() {
        isSubmitting = true;
        login_error = email_error = password_error = repeat_error = turnstile_error = "";

        const form = document.querySelector("form");
        const formData = new FormData(form);

        const login = formData.get("login")?.trim();
        const email = formData.get("email")?.trim().toLowerCase();
        const password = formData.get("password");
        const passwordRepeat = formData.get("password_repeat");
        // const promocode = formData.get("promocode")?.trim();

        let hasError = false;

        user_agreement_error = "";

        if (!user_agreement) {
            user_agreement_error = "Ви повинні погодитися з умовами.";
            hasError = true;
        }

        if (!login || login.length < 3) {
            login_error = "Логін має містити мінімум 3 символи.";
            hasError = true;
        }

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            email_error = "Введіть коректну E-mail адресу.";
            hasError = true;
        } else if (isBlockedEmail(email)) {
            email_error = "Цей домен електронної пошти не підтримується.";
            hasError = true;
        }

        if (!password || password.length < 6) {
            password_error = "Пароль має бути мінімум 6 символів.";
            hasError = true;
        }

        if (password !== passwordRepeat) {
            repeat_error = "Паролі не співпадають.";
            hasError = true;
        }

        if (!token) {
            turnstile_error = "Проблема з перевіркою. Спробуйте ще раз.";
            hasError = true;
        }

        if (hasError) {
            isSubmitting = false;
            return;
        }

        formData.append("cf_turnstile_token", token);

        try {
            const res = await axiosInstance.post("/register/", formData);
            const result = res.data;
            if (result.status === true) {
                userEmail.set(email);
                //console.log("✅ Реєстрація успішна:", result);
                changeFormStep("confirm-email");
            }
        } catch (err) {
            console.error("❌ Помилка реєстрації:", err?.response?.data || err);
            if (err?.response?.data?.detail) {
                const message = err.response.data.detail;

                if (message.includes("логіном") || message.includes("логін")) {
                    login_error = message;
                } else if (message.includes("поштою") || message.includes("email")) {
                    email_error = message;
                } else {
                    email_error = message;
                }
            } else {
                email_error = "Помилка при реєстрації. Спробуйте пізніше.";
            }
        } finally {
            isSubmitting = false;
        }
    }
</script>

<form on:submit|preventDefault={register}>
    <div class="inputs">
        <label class="input" class:error={login_error}>
            <div class="icon"><img src={UserIcon} alt="Login" /></div>
            <input type="text" name="login" placeholder="Вкажіть логін" required />
        </label>
        {#if login_error}
            <span class="span-error">{login_error}</span>
        {/if}

        <label class="input" class:error={email_error}>
            <div class="icon"><img src={EmailIcon} alt="Email" /></div>
            <input type="email" name="email" placeholder="Введіть свою E-mail адресу" required />
        </label>
        {#if email_error}
            <span class="span-error">{email_error}</span>
        {/if}

        <label class="input" class:error={password_error}>
            <div class="icon"><img src={PassIcon} alt="Password" /></div>
            <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="*Вигадайте надійний пароль"
                required
            />
            <button type="button" class="eye" on:click={() => (showPassword = !showPassword)}>
                {showPassword ? "🙈" : "👁️"}
            </button>
        </label>
        {#if password_error}
            <span class="span-error">{password_error}</span>
        {/if}

        <label class="input" class:error={repeat_error}>
            <div class="icon"><img src={PassIcon} alt="Password Repeat" /></div>
            <input
                type={showRepeat ? "text" : "password"}
                name="password_repeat"
                placeholder="Повторіть пароль"
                required
            />
            <button type="button" class="eye" on:click={() => (showRepeat = !showRepeat)}>
                {showRepeat ? "🙈" : "👁️"}
            </button>
        </label>
        {#if repeat_error}
            <span class="span-error">{repeat_error}</span>
        {/if}

        <!-- <label class="input">
            <div class="icon"><img src={GiftIcon} alt="Promocode" /></div>
            <input type="text" name="promocode" placeholder="Промокод" />
        </label> -->

        <div class="form-buttons">
            <div class="payment-button">
                <button class="btn btn-no-primary" type="button" on:click={() => changeFormStep("authorization")}>
                    В МЕНЕ Є АКАУНТ
                </button>
            </div>
            <div class="payment-button">
                <button class="btn btn-primary">ЗАРЕЄСТРУВАТИСЬ</button>
            </div>
        </div>

        <div class="checkbox">
            <label class="custom-checkbox" for="user_agreement">
                <input type="checkbox" name="user_agreement" id="user_agreement" bind:checked={user_agreement} />
                <span class="checkmark"></span>
            </label>
            <p>Ознайомлений(на) з <a href="/{$locale}/user-agreement">угодою користувача</a></p>
        </div>
        {#if user_agreement_error}
            <span class="span-error">{user_agreement_error}</span>
        {/if}

        <div style="margin-left: auto; margin-right: auto; margin-top: 30px;">
            <Turnstile on:token={e => (token = e.detail)} />
        </div>
    </div>
</form>

<Spinner isSpinner={isSubmitting} />

<style lang="scss">
    @import "/src/lib/scss/main";

    .span-error {
        color: #e74e4e;

        &:empty {
            display: none;
        }
    }

    form {
        width: 580px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 0 10px 0 10px;

        .input {
            position: relative;

            .eye {
                position: absolute;
                right: 12px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                cursor: pointer;
                font-size: 16px;
                color: #fff;
            }

            input {
                padding-right: 36px;
            }
        }

        & > .inputs {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 15px;

            & > .error {
                border: 0.5px solid #e74e4e !important;
            }

            .dropdown-img {
                width: 24px;
                height: 24px;
            }

            .arrow-img {
                width: 12px;
                height: 17px;
                transition: transform 0.3s ease;

                &.rotate {
                    transform: rotate(-180deg);
                }
            }
        }

        .payment-button {
            width: 100%;
            height: 64px;

            & > button {
                font-size: 18px;
                line-height: 140%;
                text-transform: uppercase;
                // color: #232323;
                font-weight: 900;
                font-style: italic;
            }
        }

        .bonus-main {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            row-gap: 10px;
        }

        .bonus-wrapper {
            display: flex;
            align-items: center;

            .bonus {
                border-radius: 10px;
                width: 47px;
                height: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                font-style: italic;
                font-size: 9pt;
                color: #0f0f0f;
                background: #fed500;
                margin-right: 10px;
            }

            p {
                font-weight: normal;
                font-style: normal;
                font-size: 9pt;
                color: #fffbef;
            }
        }

        .checkbox {
            color: #fffbef;

            p {
                font-size: 11pt;
                line-height: 140%;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.4);

                a {
                    font-weight: 500;
                    text-decoration: underline;
                    text-decoration-skip-ink: none;
                    color: #fffbef;
                }
            }
        }
    }

    .form-buttons {
        display: flex;
        // flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 20px;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 12px;
        }
    }

    @media (max-width: 768px) {
        form {
            width: 100%;
            padding: 0 20px;

            .payment-button {
                height: auto;

                & > button {
                    width: 100%;
                    padding: 14px 0;
                    font-size: 16px;
                }
            }

            .inputs {
                gap: 12px;
            }

            .checkbox {
                p {
                    font-size: 10pt;
                    line-height: 130%;
                    text-align: left;
                }
            }

            .span-error {
                font-size: 12px;
            }

            .input {
                input {
                    font-size: 14px;
                    padding: 12px 50px 12px 50px;
                }

                .eye {
                    font-size: 14px;
                    right: 10px;
                }

                .icon img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
</style>
